export default __webpack_public_path__ + "static/media/sectorImg2.8920e3a8.png";